import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import styles from './FriendInteractionsButtons.scss'
import { CTA } from 'common/styleguide/CTA'
import { SEND_MESSAGE_DIALOG } from 'common/dialogs/SendMessage'
import { CONFIRM_REMOVE_FRIEND_DIALOG } from 'common/dialogs/ConfirmRemoveFriend'
import { Msg, commonCTAs } from 'lib/localization'
import { friendsSelectors } from 'data/reducers/friends'
import { userActions } from 'data/resources/users'
import { FormattedMessage as T, defineMessages, injectIntl } from 'react-intl'

const messages = defineMessages({
  addFriend: {
    id: 'FriendInteractionsButtons.addFriend',
    defaultMessage: 'Add Friend'
  },
  message: {
    id: 'FriendInteractionsButtons.message',
    defaultMessage: 'Message'
  },
  removeFriend: {
    id: 'FriendInteractionsButtons.removeFriend',
    defaultMessage: 'Remove Friend'
  },
  cancelRequest: {
    id: 'FriendInteractionsButtons.cancelRequest',
    defaultMessage: 'Click to cancel request'
  }

})

class _FriendInteractionsButtons extends React.PureComponent {
  sendMessage = () => {
    const { showDialog } = this.props
    showDialog(SEND_MESSAGE_DIALOG)
  }

  requestFriend = () => {
    const { user, befriendUser } = this.props
    befriendUser(user.id)
  }

  cancelPendingRequest = () => {
    const { user, unfriendUser } = this.props
    unfriendUser(user.id)
  }

  confirmFriend = () => {
    const { user, confirmFriendRequest } = this.props
    confirmFriendRequest(user.id)
  }

  removeFriend = () => {
    const { showDialog } = this.props
    showDialog(CONFIRM_REMOVE_FRIEND_DIALOG)
  }

  render () {
    // NOTE: userIsFriend is different from currentUserIsFriend below because
    // the first checks for user.id in currentUser's friends, while the latter
    // checks for currentUser.id in user's friends. we need the former in order
    // to show an `unfriend` button if user has set their profile to private.
    const {
      user,
      currentUser,
      friends,
      userPendingIncomingFriendIds,
      userPendingOutgoingFriendIds,
      privateUser,
      userIsFriend,
      intl
    } = this.props
    const loggedInUser = !!currentUser.id
    const currentUserIsFriend = !!friends.find(f => f.id === currentUser.id)
    const currentUserIsUser = currentUser.id === user.id
    const incomingFriendRequestPending = userPendingIncomingFriendIds.includes(user.id)
    const outgoingFriendRequestPending = userPendingOutgoingFriendIds.includes(user.id)

    return (
      <div className={styles.CTAs}>
        {!loggedInUser && <Fragment>
          <CTA inline margins={false} href='/signup'><Msg m={messages.addFriend} /></CTA>
          {privateUser
            ? <CTA inline margins={false} link onClick={() => browserHistory.goBack()}><Msg m={commonCTAs.goBack} /></CTA>
            : <CTA className={styles.collapseCTA} inline link margins={false} href='/signup'><Msg m={messages.message} /></CTA>}
        </Fragment>}
        {loggedInUser && !currentUserIsFriend && !currentUserIsUser && !userIsFriend && <Fragment>
          {incomingFriendRequestPending && <CTA inline margins={false} onClick={this.confirmFriend}>
            <T id='FriendInteractionsButtons.acceptFR' defaultMessage='Accept Friend Request' />
          </CTA>}
          {outgoingFriendRequestPending && !incomingFriendRequestPending && <CTA inline margins={false} onClick={this.cancelPendingRequest} key='tippyRefreshHack' data-tip title={intl.formatMessage(messages.cancelRequest)} data-tippy-placement='bottom'>
            <T id='FriendInteractionsButtons.requestPending' defaultMessage='Request Pending' />
          </CTA>}
          {!outgoingFriendRequestPending && !incomingFriendRequestPending && <CTA inline margins={false} onClick={this.requestFriend}>
            <Msg m={messages.addFriend} />
          </CTA>}
          {privateUser
            ? <CTA inline margins={false} link onClick={() => browserHistory.goBack()}><Msg m={commonCTAs.goBack} /></CTA>
            : <CTA className={styles.collapseCTA} inline link margins={false} onClick={this.sendMessage}><Msg m={messages.message} /></CTA>}
        </Fragment>}
        {currentUserIsFriend && <Fragment>
          <CTA style={{ paddingLeft: 0, paddingRight: 0 }} inline link margins={false} onClick={this.sendMessage}>Send Message</CTA>
          <CTA className={styles.collapseCTA} inline link margins={false} onClick={this.removeFriend}><Msg m={messages.removeFriend} /></CTA>
        </Fragment>}
        {userIsFriend && <Fragment>
          <CTA inline margins={false} onClick={this.removeFriend}><Msg m={messages.removeFriend} /></CTA>
          <CTA inline margins={false} link onClick={() => browserHistory.goBack()}> browserHistory.goBack()}><Msg m={commonCTAs.goBack} /></CTA>
        </Fragment>}
        {currentUserIsUser && <CTA href='/settings/account' inline margins={false}><Msg m={commonCTAs.editProfile} /></CTA>}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const userId = ownProps.userId || (ownProps.user && ownProps.user.id)

  return {
    currentUser: state.currentUser,
    friends: friendsSelectors.userFriends(state, userId),
    userPendingIncomingFriendIds: friendsSelectors.userPendingIncomingFriendIds(state, state.currentUser.id),
    userPendingOutgoingFriendIds: friendsSelectors.userPendingOutgoingFriendIds(state, state.currentUser.id)
  }
}

const mapDispatchToProps = {
  befriendUser: userActions.befriend,
  unfriendUser: userActions.unfriend,
  loadFriendRequests: userActions.friendRequests,
  confirmFriendRequest: userActions.confirmFriendRequest,
  declineFriendRequest: userActions.declineFriendRequest
}

export const FriendInteractionsButtons = connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(_FriendInteractionsButtons))
